// src/pages/ChatWithAI/components/dialogs/AnexarClienteDialog.js
import React, { useState } from 'react';
import axios from 'axios';
import './AnexarDialog.css';

const AnexarClienteDialog = ({ onClose, onAnexar }) => {
  const [clientCode, setClientCode] = useState('');
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [error, setError] = useState(null);

  const handleClientCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').substring(0, 5);
    setClientCode(value);
    setPreview(null);
    setError(null);
  };

  const handleBuscarPreview = async () => {
    if (!/^\d{5}$/.test(clientCode)) {
      setError('Código deve ter exatamente 5 dígitos');
      return;
    }

    setLoadingPreview(true);
    setError(null);
    setPreview(null);

    try {
      const response = await axios.get(`/api/clients/${clientCode}`);

      if (response.data.success) {
        const clientData = response.data.data;
        
        // Montar preview do que será anexado
        const previewText = JSON.stringify(clientData, null, 2);
        const wordCount = previewText.trim().split(/\s+/).length;

        setPreview({
          data: clientData,
          wordCount,
          text: previewText
        });
      }
    } catch (err) {
      console.error('❌ Erro ao buscar cliente:', err);
      setError(err.response?.data?.message || 'Cliente não encontrado');
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleBuscarPreview();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!preview) {
      setError('Busque o cliente primeiro para ver o preview');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onAnexar(clientCode);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="anexar-dialog-overlay" onClick={onClose}>
      <div className="anexar-dialog anexar-dialog-large" onClick={(e) => e.stopPropagation()}>
        <div className="anexar-dialog-header">
          <h3>👤 Anexar Cliente (Sistema Forense)</h3>
          <button onClick={onClose} className="anexar-dialog-close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="anexar-dialog-content">
          <div className="form-group">
            <label>Código do Cliente (5 dígitos)</label>
            <div className="client-code-input-group">
              <input
                type="text"
                placeholder="Ex: 12345"
                value={clientCode}
                onChange={handleClientCodeChange}
                onKeyPress={handleKeyPress}
                className="client-code-input"
                maxLength={5}
                autoFocus
              />
              <button
                type="button"
                onClick={handleBuscarPreview}
                className="buscar-preview-btn"
                disabled={clientCode.length !== 5 || loadingPreview}
              >
                {loadingPreview ? 'Buscando...' : 'Buscar'}
              </button>
            </div>
            <small className="input-hint">
              Digite o código de 5 dígitos do cliente no sistema Forense
            </small>
          </div>

          {preview && (
            <div className="client-preview-container">
              <div className="client-preview-header">
                <span className="preview-icon">✅</span>
                <span className="preview-title">Preview dos dados que serão anexados</span>
                <span className="preview-words">{preview.wordCount} palavras</span>
              </div>
              
              <div className="client-preview-data">
                {preview.data.nome && (
                  <div className="preview-field">
                    <strong>Nome:</strong> {preview.data.nome}
                  </div>
                )}
                {preview.data.email && (
                  <div className="preview-field">
                    <strong>Email:</strong> {preview.data.email}
                  </div>
                )}
                {preview.data.telefone && (
                  <div className="preview-field">
                    <strong>Telefone:</strong> {preview.data.telefone}
                  </div>
                )}
                
                <details className="preview-json-details">
                  <summary>Ver JSON completo</summary>
                  <pre className="preview-json">{preview.text}</pre>
                </details>
              </div>
            </div>
          )}

          {error && (
            <div className="anexar-error">
              ⚠️ {error}
            </div>
          )}

          <div className="anexar-hint">
            <strong>💡 Como funciona:</strong><br />
            1. Digite o código de 5 dígitos do cliente<br />
            2. Clique em "Buscar" para ver preview dos dados<br />
            3. Se estiver correto, clique em "Anexar Cliente"
          </div>

          <div className="anexar-dialog-actions">
            <button
              type="button"
              onClick={onClose}
              className="anexar-btn-cancel"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="anexar-btn-submit"
              disabled={!preview || loading}
            >
              {loading ? 'Anexando...' : 'Anexar Cliente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnexarClienteDialog;// src/pages/ChatWithAI/components/dialogs/AnexarClienteDialog.js
